<template>
    <CRow class="justify-content-center home-form">
        <CCol xl="9" style="max-width: 950px">
            <CCard class="mb-5">
                <CCardHeader class="d-flex align-items-center">
                    <span>Advanced Search</span>
                    <CButton class="p-0 ml-auto" @click="hideFilter">
                        <!--suppress HtmlUnknownTag -->
                        <CIcon size="lg" style="color:#977a7a" name="cilX"/>
                    </CButton>
                </CCardHeader>
                <CCardBody>
                    <CForm @submit.prevent="applyFilter">
                        <CRow class="justify-content-center align-items-center">
                            <CCol md="5"></CCol>
                            <CCol md="7">
                                <CRow class="mb-3">
                                    <CCol md="4">
                                        <label>Type</label>
                                    </CCol>
                                    <CCol md="8">
                                        <CInputRadioGroup
                                            class="mb-3"
                                            custom
                                            :options="[
                                                {value: 'Boat', label: 'Boat'},
                                                {value: 'Erg', label: 'Erg'},
                                            ]"
                                            :inline=true
                                            :checked.sync="filter.type"
                                        />
                                    </CCol>
                                </CRow>

                                <CRow class="mb-3" v-show="filter.type==='Boat'">
                                    <CCol md="4">
                                        <label>Crew</label>
                                    </CCol>
                                    <CCol md="8">
                                        <div class="form-inline">
                                            <CInputCheckbox
                                                v-for="(value, key) in crewNums"
                                                :key="key"
                                                :label="value"
                                                :value="value"
                                                :inline=true
                                                custom
                                                @update:checked="checked"
                                            />
                                        </div>
                                    </CCol>
                                </CRow>

                                <CRow class="mb-3">
                                    <CCol md="4">
                                        <label>SPM</label>
                                    </CCol>
                                    <CCol md="8" class="inline">
                                        <CRow>
                                            <CCol col="4">
                                                <CInput v-model="filter.strokes_min" type="number" size="sm" min="0" step="1"></CInput>
                                            </CCol>
                                            <CCol col="2" class="d-flex justify-content-center">
                                                <div><span>...</span></div>
                                            </CCol>
                                            <CCol col="4">
                                                <CInput v-model="filter.strokes_max" type="number" size="sm" :min="filter.strokes_min"></CInput>
                                            </CCol>
                                        </CRow>
                                    </CCol>
                                </CRow>

                                <CRow class="mb-4 align-items-center">
                                    <CCol md="4">
                                        <label class="mb-0">Minimum video quality</label>
                                    </CCol>
                                    <CCol md="8" class="inline">
                                        <CRow>
                                            <CCol col="10">
                                                <v-select
                                                    v-model="filter.videoQuality"
                                                    placeholder="Any..."
                                                    :searchable="false"
                                                    :options="videoQualityOptions"/>
                                            </CCol>
                                        </CRow>
                                    </CCol>
                                </CRow>

                            </CCol>
                        </CRow>

                        <CRow>
                            <CCol sm="12" class="ml-auto text-right">
                                <CButton
                                    color="success"
                                    class="px-5"
                                    type="submit"
                                >
                                    Search
                                </CButton>
                            </CCol>
                        </CRow>
                    </CForm>
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
import {trainingProfileSearch} from "@/scripts/queries";

export default {
    data() {
        return {
            crewNums: ['1', '2', '4', '8'],
            filter: {
                strokes_min: "0",
                strokes_max: "0",
                crew: [],
                type: 'Boat',
                videoQuality: undefined,
            },
            videoQualityOptions: [
                {value:1, label:'Low'},
                {value:2, label:'Fair'},
                {value:3, label:'Good'},
                {value:4, label:'Perfect'},
            ],
            styleOptions: [],
        }
    },
    methods: {
        hideFilter() {
            this.$emit('hideFilter')
        },
        applyFilter() {
            const filter = JSON.parse(JSON.stringify(this.filter));
            if (filter.type !== 'Boat') {
                delete filter.crew;
            }
            this.$emit('applyFilter', filter);
        },
        checked(checked, e) {
            let value = e.target.value * 1,
                index = this.filter.crew.indexOf(value);
            if (checked && index === -1) {
                this.filter.crew.push(value);
            } else if (index !== -1) {
                this.filter.crew.splice(index, 1);
            }
        },
        verifyStrokes: function() {
            if (this.filter.strokes_max < this.filter.strokes_min) {
                this.filter.strokes_max = this.filter.strokes_min;
            }
        }
    },
    watch: {
        'filter.strokes_min': function () {
            this.verifyStrokes();
        },
        'filter.strokes_max': function () {
            this.verifyStrokes();
        }
    },
    async created() {
        const options = await trainingProfileSearch();
        this.styleOptions = options.map((profile) => {
            return {
                value: profile.name,
                label: profile.name
            }
        })
    }
}
</script>

<style lang="scss">
.vs__search {
    color: #3c4b64;
}
.inline .form-group {
    margin-bottom: 0;
}
</style>